fourToldApp.factory("conversation_history", function($rootScope, $window, services, storage, cryptool) {
    checkValueUrl = function(str) {
        try {
            var result = JSON.parse(str);
            if (result.url)
                return result;
            else return false;
        } catch (e) {
            return false;
        }
    };

    myFunction = function(position) {
        var elmnt = document.getElementById(position);
        elmnt.scrollIntoView();
    }
    
    function orderBy(data, where) {
        var sortedMessages = data.sort(function(a, b) {
            var splitA = a.from.split(".")
            var splitB = b.from.split(".")

            if(splitA[1] === "aga@4told"){
                a = JSON.parse(a.body)
                a =  new Date(a.body.timestamp);
            } else a = new Date(a.sentDate);

            if(splitB[1] === "aga@4told"){
                b = JSON.parse(b.body)
                b =  new Date(b.body.timestamp);
            } else b = new Date(b.sentDate);

            if(where === 'login')
                return a - b;
            else return b - a;
        });
        return sortedMessages;
    };
    conversationComparator = function(a, b){                     
        return  a.body.id === b.body.id && a.target === b.target && a.fromJabberId.includes(".aga") && a.type === b.type
    }
    deduplicate = function(result, conversation) { 
        return result.find(x => conversationComparator(JSON.parse(conversation.body), JSON.parse(x.body)))? result : [...result, conversation]
    }

    return {
        setChatData: function(response, arrayMessage, where, positionScroll, alternateChannel) {
            $rootScope.progressCircular = undefined;
            response.conversations = response.conversations.reduce(deduplicate, []);
            var openfireContactServer = cryptool.decryptData($window.sessionStorage.getItem("openfireContactServer"));
            var conversations = orderBy(response.conversations, where);
            if (conversations) {
                for (var i = 0; i < conversations.length; i++) {
                    var result = response.conversations[i].from.split('@');
                    var agaUser = openfireContactServer.split('@')[0];
                    switch (result[0]) {
                        case response.me:
                            var data = JSON.parse(response.conversations[i].body);
                            var textMessage = data.body.message;
                            var type = "sent";
                            var url = undefined;
                            var format = undefined;
                            var typeDocument = undefined;
                            var checkUrl = checkValueUrl(data.body.value);
                            if (checkUrl !== false) {
                                format = checkUrl.format;
                                url = checkUrl.url;
                                typeDocument = checkUrl.type;
                            }
                            if (data.body.messageToShowInChat) textMessage = data.body.messageToShowInChat;
                            var message = {
                                id: data.body.id,
                                text: textMessage,
                                body: data.body,
                                date: new Date(response.conversations[i].sentDate),
                                type: type,
                                layout: "end",
                                metadata: data.metadata,
                                url: url,
                                format: format,
                                typeDocument: typeDocument,
                                icon: "checkblue.png",
                                ack: true,
                                clientInterface: data.clientInterface
                            }
                            if(positionScroll !== null)
                                arrayMessage.unshift(message);
                            else storage.setLocalStorages(message, arrayMessage, alternateChannel);
                            break;
                        case agaUser:
                            var data = JSON.parse(response.conversations[i].body);
                            if(data.metadata) {
                                if(!(data.metadata!=null && data.metadata.help!=null && data.metadata.instruction!=null && data.metadata.instruction.silent === true || (data.metadata.instruction && data.metadata.instruction.hideText === true)))
                                {
                                    data.metadata["type_meta"] = data.type;
                                    var message = {
                                    text: data.body.message,
                                    body: data.body,
                                    date: new Date(data.body.timestamp),
                                    id: data.body.id,
                                    layout: "start",
                                    isAction: (data.type === "ACTION"),
                                    metadata: data.metadata,
                                    metadataObj: data.metadata
                                }
                                    if(data.metadata.processControl)
                                        $window.localStorage.setItem('aga_status', JSON.stringify(data));
                                    else if(!data.metadata.processControl && $window.localStorage.getItem('aga_status'))
                                        $window.localStorage.removeItem('aga_status');
                                    if(positionScroll !== null)
                                        arrayMessage.unshift(message);
                                    else storage.setLocalStorages(message, arrayMessage, alternateChannel);
                                }
                            }
                            break;
                        default:
                    }
                    var datx = JSON.parse(response.conversations[i].body);
                    if(datx.metadataObj && datx.metadataObj.constraints && datx.metadataObj.constraints.disableRetry === true) {
                        for(var i = 0; i < messages.length; i++) {
                          if( messages[i].metadataObj &&  messages[i].metadataObj.instruction &&  messages[i].metadataObj.instruction.retrydefault) {
                            messages[i].metadataObj.instruction.retrydefault = false;
                          }
                        }
                    }
                }
            }
            if(positionScroll)
                myFunction(positionScroll);
        },
        deduplicate: deduplicate
    }
});

fourToldApp.service('storage', function($window, $localStorage) {
    this.setLocalStorages = function(data, arrayMessage, alternateChannel) {
        if(data && data.metadataObj){
            $window.localStorage.setItem('metadataObj', JSON.stringify(data.metadataObj));
            $localStorage.typeSelect = undefined;
        }
        else $window.localStorage.setItem('metadataObj', undefined);
        
        if(data && data.metadata && data.metadata.instruction && data.metadata.instruction.confirmation) {
          $window.sessionStorage.setItem("confirmDialog", JSON.stringify(data.metadata.instruction));
        } else {
            $window.sessionStorage.removeItem("confirmDialog"); 
        }
        if(data && data.id)
            $window.sessionStorage.setItem('idAga', data.id);
    
        if(data && data.body && data.body.constraints && data.body.constraints.formBody)  {
            $window.sessionStorage.setItem("dataNotification", JSON.stringify(data));
        } else if(data && data.body && data.body.constraints && data.body.constraints.type == "updatePassword")  {
            $window.sessionStorage.setItem("dataNotification", JSON.stringify(data));
        } 
        else{
            $window.sessionStorage.removeItem("dataNotification");
        }

        if(arrayMessage && !alternateChannel){ //chat princial
            arrayMessage.push(data);
            $localStorage.msg = arrayMessage;
        }

        else if(alternateChannel && arrayMessage){ //chat alterno
            if(!arrayMessage.find(msg => msg.id === data.id) || data.type === 'sent' || data.type === 'RETRY') {
                arrayMessage.push(data);
                alternateChannel.body = arrayMessage; //variable localStorage
            }
        }
    };
  });
